export default __webpack_public_path__ + "static/media/filter.664113b9.JPG";